import { render, staticRenderFns } from "./ManagementPlan.vue?vue&type=template&id=af3efa00&"
import script from "./ManagementPlan.vue?vue&type=script&lang=ts&"
export * from "./ManagementPlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af3efa00')) {
      api.createRecord('af3efa00', component.options)
    } else {
      api.reload('af3efa00', component.options)
    }
    module.hot.accept("./ManagementPlan.vue?vue&type=template&id=af3efa00&", function () {
      api.rerender('af3efa00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/diagnosis/ManagementPlan.vue"
export default component.exports